import { canAccessRoute, canAccessTab, initializePermissions, permissionsReady } from '~/utils/auth/routeController';
import { useAuth } from '~/composables/useAuth';
// import { dynamicRolesReady } from '~/utils/auth/menuItemController';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { isAuthenticated, checkAuth, isExpenseEnabled } = useAuth();

  if (!isAuthenticated.value) {
    await checkAuth();
  }

  if (isAuthenticated.value && !permissionsReady.value) {
    await initializePermissions();
  }

  if (!isAuthenticated.value) {
    if (to.path !== '/login' && to.path !== '/forgot-password' && to.path !== '/reset-password') {
      return navigateTo('/login');
    }
  } else {
    if (to.path === '/login' || to.path === '/forgot-password' || to.path === '/reset-password') {
      return navigateTo('/');
    }
    if (to.path === '/expenses' || to.path === '/recurring-expenses') {
      if (!canAccessRoute(to.path)) {
        return useRouter().push({
          path: '/forbidden',
          query: { from: from.path }
        });
      }
      if (Object.prototype.hasOwnProperty.call(to.query, 'tab')) {
        const tab = to.query.tab as string;
        // // These tabs will be in everyone in the expense/recurring-expenses route
        // const expenseTabs = [
        //   'all_expenses',
        //   'submitted_by_me',
        //   'pending_approval_by_me',
        //   'default',
        //   'payroll',
        //   // 'petty_cash'
        // ];
        // If the tab is not in the expenseTabs array, then it will be a custom expense and we have added custom expense permission with custom_exp3
        // if (!expenseTabs.includes(tab)) {
        //   tab = 'custom_exp3';
        // }
        if (!canAccessTab(tab as string)) {
          return useRouter().push({
            path: '/forbidden',
            query: { from: from.path }
          });
        }
      }
    }

    if (
      (!isExpenseEnabled.value && to.path.includes('/expenses')) ||
      (!isExpenseEnabled.value && to.path.includes('/budgets'))
    ) {
      return navigateTo('/forbidden/no-subscription');
    }

    if (!canAccessRoute(to.path) && to.path !== '/forbidden') {
      return useRouter().push({
        path: '/forbidden',
        query: { from: from.path }
      });
    }
  }
});
